import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M29.69 6H2.31C1.035 6 0 7.035 0 8.305V23.38C0 24.655 1.035 25.69 2.31 25.69H29.695C30.97 25.69 32.005 24.655 32 23.385V8.305C32 7.035 30.965 6 29.69 6ZM16.925 21.075H13.85V15.075L10.775 18.92L7.7 15.075V21.075H4.615V10.615H7.69L10.765 14.46L13.84 10.615H16.915V21.075H16.925ZM23.69 21.23L19.075 15.845H22.15V10.615H25.225V15.845H28.3L23.69 21.23Z'],
  name: 'brandMarkdown',
  oldName: 'fabMarkdown'
} as IconDefinition
